module.exports = function getResource(label, vars = []) {
    const resources = {
        applyRougeRewards: 'Apply Rouge Rewards',
        rougeReward: `$${vars[0]} Rouge Reward`,
        expires: `*$${vars[0]} off* • Exp ${vars[1]}`,
        expiresDate: `Expires ${vars[0]}`,
        applied: `*$${vars[0]} off* applied`,
        switchToUS: 'Rouge Reward can only be used in the country where the reward was redeemed. Please switch to our US shopping experience to use this reward.',
        switchToCA: 'Rouge Reward can only be used in the country where the reward was redeemed. Please switch to our Canada shopping experience to use this reward.'
    };

    return resources[label];
};
